import React, { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { ReactComponent as SearchIcon } from "assets/icons/search_main.svg";
import useSaveSearch from "hooks/useSaveSearch";
import SaveSearchCardSkeleton from "components/Skeleton/SaveSearchCardSkeleton";
import SaveSearchCard from "components/Card/SaveSearchCard";
import RemoveWarningDialog from "components/Dialog/RemoveWarningDialog";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import { ReactComponent as ArrowRightIcon } from "assets/icons/slider_arrow_right.svg";
import useAuth from "hooks/useAuth";

const DashboardSaveSearches = () => {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const {
    saveSearches,
    removeSaveSearch,
    isFetchingSaveSearch,
    fetchSaveSearches,
  } = useSaveSearch();
  const [isSaveRemovePopupOpen, setIsSaveRemovePopupOpen] = useState(false);
  const [selectedSearch, setSelectedSearch] = useState(null);
  const { user } = useAuth();

  // Slider settings
  const settings = {
    modules: [Navigation, Pagination],
    navigation: {
      nextEl: `.swiper-next`,
      prevEl: `.swiper-prev`,
    },
    slidesPerView: "auto",
    pagination: false,
    freeMode: true,
    spaceBetween: 35,
  };

  const handleSaveSearchRemove = async () => {
    if (selectedSearch) {
      await removeSaveSearch(selectedSearch?._id);
      setSelectedSearch(null);
      setIsSaveRemovePopupOpen(false);
    }
  };

  const openRemovePopup = (search) => {
    setSelectedSearch(search);
    setIsSaveRemovePopupOpen(true);
  };

  // Fetch save searches
  useEffect(() => {
    fetchSaveSearches();
  }, [user]);

  // Save search pagination function
  const handleLoadMoreSaveSearch = () => {
    if (saveSearches?.pagination?.nextPage && !isFetchingSaveSearch) {
      fetchSaveSearches(saveSearches?.pagination?.nextPage);
    }
  };

  return (
    <div className=" overflow-hidden relative md:h-[295px] rounded-[10px] bg-[#262626] w-full max-w-[1550px] mx-auto py-[25px]">
      {saveSearches?.results?.length > 0 ? (
        <Swiper
          onReachEnd={handleLoadMoreSaveSearch}
          className="save_search_slider"
          {...settings}
        >
          {saveSearches?.results?.map((search, index) => (
            <SwiperSlide key={search._id}>
              <SaveSearchCard
                searchInfo={search}
                isDeleteVisible
                imgStyle={{
                  width: isMobile ? "100%" : 254,
                  height: isMobile ? 200 : 243,
                }}
                contentStyle={{ width: isMobile ? "100%" : 284 }}
                onDelete={() => openRemovePopup(search)}
              />
            </SwiperSlide>
          ))}

          {isFetchingSaveSearch &&
            Array.from({ length: 3 }).map((_, index) => (
              <SwiperSlide key={index}>
                <SaveSearchCardSkeleton />
              </SwiperSlide>
            ))}
        </Swiper>
      ) : (
        <div className="flex flex-col justify-center items-center h-full">
          <SearchIcon className="w-[135px] h-[135px] text-white stroke-1 pr-5" />
          <p className="text-[24px] font-semibold leading-[30px] text-white text-center mt-5">
            Nessuna Ricerca Salvata e Monitorata
          </p>
        </div>
      )}
      {/* Custom Navigation Arrows */}
      <div
        className={`swiper-next absolute right-[0px] top-0 bottom-0 z-[1] h-full w-[86px] grid place-items-center`}
        style={{
          background:
            "linear-gradient(270deg, #000000 40.7%, rgba(38, 38, 38, 0) 100%)",
        }}
      >
        <div className="bg-white w-[61px] h-[61px] rounded-[10px] grid place-items-center cursor-pointer">
          <ArrowRightIcon width={17} height={34} fill="black" />
        </div>
      </div>
      <div
        className={`swiper-prev absolute left-[0px] rotate-180 top-0 bottom-0 z-[1] h-full w-[86px] grid place-items-center`}
        style={{
          background:
            "linear-gradient(270deg, #000000 40.7%, rgba(38, 38, 38, 0) 100%)",
        }}
      >
        <div className="bg-white w-[61px] h-[61px] rounded-[10px] grid place-items-center cursor-pointer">
          <ArrowRightIcon width={17} height={34} fill="black" />
        </div>
      </div>
      <RemoveWarningDialog
        warningText={`Vuoi rimuovere la ricerca ${
          selectedSearch ? selectedSearch?.searchName : ""
        }?`}
        isOpen={isSaveRemovePopupOpen}
        isClose={() => setIsSaveRemovePopupOpen(false)}
        onClick={handleSaveSearchRemove}
      />
    </div>
  );
};

export default DashboardSaveSearches;
